exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3t3Cf{padding-top:0;position:relative;z-index:1;margin-bottom:20px}._3H05r{margin:0 auto}.S6brV{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._2xDUQ{width:calc(100% - 300px);padding-right:20px;position:relative}._1RRvG{background-color:#fff;border-bottom:1px solid #e0e0e0;border-radius:2px 2px 0 0}.gJk9f{padding:0}._1HsJe{margin-bottom:15px}._1tWu1{font-size:1.2em;text-indent:15px}", ""]);

// exports
exports.locals = {
	"page": "_3t3Cf page",
	"container": "_3H05r container",
	"flexRow": "S6brV flexRow",
	"mainCell": "_2xDUQ",
	"navWrapper": "_1RRvG",
	"searchWrapper": "gJk9f",
	"advertContainerGl": "_1HsJe",
	"h2": "_1tWu1"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/spareparts/Spareparts.css
// module id = 2894
// module chunks = 1